import React from "react";
import api from "../../../../../core/api";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import AppModal from "../../../../modals/AppModal";
import {createAction, toastError, toastSuccess} from "../../../../../core/utils/appUtil";
import {useDispatch, useSelector} from 'react-redux'
import {RESERVATION_DELETE_SUCCESS} from "../../../../../reducers/reservation";
import {RESERVATION_MODAL_CLOSE} from "../../../../../reducers/reservationModal";
import {RESERVATION_CYCLE_DELETE_SUCCESS} from "../../../../../reducers/reservationCycle";

const DeleteSingleRentalReservation = ({reservationId, modalOpened, setModalOpened}) => {

    let dispatch = useDispatch()

    let reservation = useSelector(state => state.reservation.byId[reservationId])

    let [deleteOnlySingle, setDeleteOnlySingle] = React.useState(true)

    let deleteReservation = () => {
        if (deleteOnlySingle) {
            api.reservation.delete(reservationId).then(() => {
                toastSuccess('Rezerwacja została usunięta')
                setModalOpened(false)
                dispatch(createAction(RESERVATION_MODAL_CLOSE))
                dispatch(createAction(RESERVATION_DELETE_SUCCESS, reservationId))
            }).catch(() => {
                toastError('Wystąpił błąd');
                setModalOpened(false)
            })
        } else {
            api.reservationCycle.delete(reservation.reservation_cycle_id).then(() => {
                toastSuccess('Cykl rezerwacji został usunięty')
                setModalOpened(false)
                dispatch(createAction(RESERVATION_MODAL_CLOSE))
                dispatch(createAction(RESERVATION_CYCLE_DELETE_SUCCESS, reservation.reservation_cycle_id))
            }).catch((e) => {
                console.log(e)
                toastError('Wystąpił błąd');
                setModalOpened(false)
            })
        }
    }

    return <AppModal
        modalOpened={modalOpened}
        setModalOpened={setModalOpened}
        title={'Czy na pewno chcesz usunąć rezerwację'}
        cancelText='Nie'
        submitText='Tak'
        type='confirmation'
        submitAction={deleteReservation}
    >
        {reservation.reservation_cycle_id !== null && <RadioGroup defaultValue={true} onChange={(e) => setDeleteOnlySingle(e.target.value === 'true')} value={deleteOnlySingle}>
            <FormControlLabel value={true} control={<Radio/>} label='Tylko ta rezerwacja'/>
            <FormControlLabel value={false} control={<Radio/>} label='Cały cykl rezerwacji'/>
        </RadioGroup>}
    </AppModal>
}

export default DeleteSingleRentalReservation;

